import React, {useState} from 'react';
// import {Link} from 'react-router-dom';
import '../styles/About.scss';
// import '../styles/StyleVars.scss'



function About() {

  const [showMore, setShowMore] = useState(false);

  const handleClick = () => setShowMore(!showMore)


  return (

    <>
    <div id='about' className='abt'>
        <div className="section-header">
            <h3>About Us</h3>
            {/* <p>Some of my projects</p> */}
        </div>

        <div className="abt_card">
          <p>
            LivEasy is a not-for-profit organization dedicated to improving the lives of vulnerable populations by providing safe shelter, nutritious food, and access to quality healthcare. 
          </p>
          <p>
            Our mission is to create a supportive environment where individuals and families can thrive, with a focus on addressing immediate needs and promoting long-term well-being and health outcomes.
          </p>
          {/* <div className={`rest ${showMore ? "more" : ''}`}>
            <p>
              Driven by a passion to 
            </p>
            <p>
              There are a lot of things I love to do. Topping the chart is learning. I can not assure you that I know or have all it takes to complete your project. However, I assure you that I can learn. I can learn as fast as is reasonably required of a human. An alpha one. I believe learning is why we are still here, else we would all be dead. Laerning keeps us alive. Learning is life. It is what my life revolves around.
            </p>
            <p>
              I understand that sleep is the most underrated thing on earth, with so many levels of abstraction; humans cannot understand, hence, I advice you always to sleep well (Take that as a freebie since technology is still working on e-candies). I love sleep. I also love to receive invites to talks that align with my interests, games (strictly Pro Evolution Soccer and scrabble) and parties (especially <span style={{fontStyle: "italic"}}>Owambe</span>). 
            </p> 
          </div>*/}

          {/* <button onClick={handleClick}>{showMore ? "Show Less": "Show More"}</button> */}
        </div>        
      </div>
    </>  
  )
}



export default About;


